import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
// import { ValidationService } from '../../../validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { CommonModule } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { MatFormField } from '@angular/material/form-field';
import { MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'app-manager-add-assets',
  templateUrl: './manager-add-assets.component.html',
  styleUrls: ['./manager-add-assets.component.scss'],
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatToolbar,MatFormField,MatRadioButton]
})
export class ManagerAddAssetsComponent implements OnInit {
  private addAssetsUrl = BaseUrlConstantsService.ADD_ASSETS;
  public clientDeviceUrl = BaseUrlConstantsService.CLIENT_DEVICES;
  private allSitesUrl = BaseUrlConstantsService.GET_SITES;
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public pid: any;
  public showList: boolean;
  public emptyMsg: boolean;
  public pageRouteRef: string;
  public lastPageRef: string;
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showSavebtn: boolean;
  public uForm: any;
  public allDevices: any;
  public sitesList: any;
  public groupList: any;
  public selectedSiteID: any;
  public breadcrumbsArray: any = [{
    page_ref: 'manager-client-list',
    page_title: 'manager Associated Clients'
  }, {
    page_ref: 'manager-assets',
    page_title: 'manager assets'
  }, {
    page_ref: 'manager-add-assets',
    page_title: 'add assets'
  }];
  public assetsID: any;

  constructor(
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    private formBuilder: FormBuilder,
    public router: Router,
    activeRoute: ActivatedRoute) {
    activeRoute.queryParams.subscribe(params => {
      this.pid = params[`pageRef`];
      if (this.pid === 'client-assets') {
        this.assetsID = params[`assets_id`];
        this.showUpdateBtn = true;
        this.showEditUsertxt = 'Edit Asset';
        this.showSavebtn = false;
      } else {
        this.showUpdateBtn = false;
        this.showEditUsertxt = 'Add Asset';
        this.showSavebtn = true;
      }
    });
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  getallSitesAndGroupsInfo() {
    const body = {
      client_id: localStorage.getItem('user_id')
    };
    this.changeService.loader(true);
    this.service.postData(this.allSitesUrl, body).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
          this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  ngOnInit() {
    this.uForm = this.formBuilder.group({
      motor_make: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      frame: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      ambient_temperature: new FormControl(''),
      insulation_class: new FormControl(''),
      motor_serial: new FormControl(''),
      rated_power: new FormControl(''),
      rated_rpm: new FormControl(''),
      rated_voltage: new FormControl(''),
      power_factor: new FormControl(''),
      temperature_sy: new FormControl(''),
      power_unit: new FormControl(''),
      site_id: new FormControl(''),
      application_id: new FormControl(''),
      device_id: new FormControl(''),
      duty: new FormControl(''),
      efficiency: new FormControl('')
    });
    this.getallDevices();
    this.getallSitesAndGroupsInfo();
  }

  getallDevices() {
    const body = {
      client_id: localStorage.getItem('user_id')
    };
    this.changeService.loader(true);
    this.service.postData(this.clientDeviceUrl, body).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
          this.allDevices = JSON.parse(JSON.stringify(res)).data.body;
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  selectSite(siteValue) {
    const body = {
      client_id: localStorage.getItem('user_id'),
      site_id: siteValue
    };
    this.changeService.loader(true);
    this.service.postData(this.getApplicationsUrl, body).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
          this.groupList = JSON.parse(JSON.stringify(res)).data.body;
        }
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  selectGroup(selectGroup) { }

  saveAsstes() {
    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        client_id: localStorage.getItem('user_id'),
        motor_make: this.uForm.value.motor_make,
        insulation_class: this.uForm.value.insulation_class,
        frame: this.uForm.value.frame,
        frame_unit: 'L',
        rated_ambient_temprature: this.uForm.value.ambient_temperature,
        rated_ambient_temprature_unit: this.uForm.value.temperature_sy,
        power_factor: this.uForm.value.power_factor,
        rated_power: this.uForm.value.rated_power,
        rated_power_unit: this.uForm.value.power_unit,
        rated_rpm: this.uForm.value.rated_rpm,
        percentage_efficiency: this.uForm.value.efficiency,
        rated_voltage: this.uForm.value.rated_voltage,
        duty: this.uForm.value.duty,
        device_id: this.uForm.value.device_id,
        site_id: this.uForm.value.site_id,
        application_id: this.uForm.value.application_id
      };
      this.changeService.loader(true);
      this.service.postData(this.addAssetsUrl, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Assets registered successfully');
          this.router.navigate(['/manager-assets']);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }

  addDevice() {
    this.router.navigate(['manager-add-assets']);
  }

  saveDevice() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    this.router.navigate(['manager-add-assets'], navigationExtras);
  }
}













  //   options: FormGroup;
//   foods: Food[] = [
//     { value: 'steak-0', viewValue: '1' },
//     { value: 'pizza-1', viewValue: '2' },
//     { value: 'tacos-2', viewValue: '3' }
//   ];

//   visible = true;
//   selectable = true;
//   removable = true;
//   addOnBlur = true;
//   readonly separatorKeysCodes: number[] = [ENTER, COMMA];
//   fruits: Fruit[] = [
//     { name: 'Tech' },
//     { name: 'Computer' },
//     { name: 'Awsome' },
//   ];
//   pid: any;
//   showList: boolean;
//   emptyMsg: boolean;

//   pageRouteRef: string;
//   lastPageRef: string;

//   breadcrumbsArray: any = [
//     "manager-client-list",
//     "manager-users-site-group",
//     "manager-assets",
//     "manager-add-assets"
//   ];

//   showUpdateBtn: boolean;
//   showEditUsertxt: string;
//   showSavebtn: boolean

//   constructor(fb: FormBuilder, public router: Router, activeRoute: ActivatedRoute) {
//     this.options = fb.group({
//       hideRequired: false,
//       floatLabel: 'auto',
//     });

//     activeRoute.queryParams.subscribe(params => {
//      this.pid = params['pageRef'];
//       if (this.pid == 'client-assets') {
//         this.showUpdateBtn = true;
//         this.showEditUsertxt = "Edit Asset";
//         this.showSavebtn = false;
//       } else {
//         this.showUpdateBtn = false;
//         this.showEditUsertxt = "Add Asset";
//         this.showSavebtn = true;
//       }
//     });
//   }


//   goToPageLink(name: string) {
//     this.router.navigate([name]);
//   }


//   ngOnInit() {

//   }



//   add(event: MatChipInputEvent): void {
//     const input = event.input;
//     const value = event.value;

//     // Add our fruit
//     if ((value || '').trim()) {
//       this.fruits.push({ name: value.trim() });
//     }

//     // Reset the input value
//     if (input) {
//       input.value = '';
//     }
//   }

//   remove(fruit: Fruit): void {
//     const index = this.fruits.indexOf(fruit);

//     if (index >= 0) {
//       this.fruits.splice(index, 1);
//     }
//   }


//   addDevice() {
//     this.router.navigate(['manager-add-assets']);
//   }

//   saveDevice() {
//     const navigationExtras = {
//       skipLocationChange: true,
//       queryParams: {
//         pid: true
//       }
//     };
//     this.router.navigate(['manager-assets'], navigationExtras);
//   }


// }
